/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './presentation/routes/__root'
import { Route as SitesRouteImport } from './presentation/routes/sites'
import { Route as RiskMatrixRouteImport } from './presentation/routes/risk-matrix'
import { Route as ResetPasswordRouteImport } from './presentation/routes/reset-password'
import { Route as PreventionPlanRouteImport } from './presentation/routes/prevention-plan'
import { Route as ExportRouteImport } from './presentation/routes/export'
import { Route as AdminRouteImport } from './presentation/routes/admin'
import { Route as AccountRouteImport } from './presentation/routes/account'
import { Route as AcceptInviteRouteImport } from './presentation/routes/accept-invite'
import { Route as IndexRouteImport } from './presentation/routes/index'
import { Route as SitesIndexRouteImport } from './presentation/routes/sites.index'
import { Route as DashboardIndexRouteImport } from './presentation/routes/dashboard.index'
import { Route as AdminIndexRouteImport } from './presentation/routes/admin.index'
import { Route as SitesSiteIdRouteImport } from './presentation/routes/sites.$siteId'
import { Route as RisksNewRouteImport } from './presentation/routes/risks.new'
import { Route as DashboardRegionsRouteImport } from './presentation/routes/dashboard.regions'
import { Route as AdminWorkUnitsRouteImport } from './presentation/routes/admin.work-units'
import { Route as AdminUsersRouteImport } from './presentation/routes/admin.users'
import { Route as AdminSitesRouteImport } from './presentation/routes/admin.sites'
import { Route as AdminRegionsRouteImport } from './presentation/routes/admin.regions'
import { Route as AdminImportRouteImport } from './presentation/routes/admin.import'
import { Route as AdminExportXlsxRouteImport } from './presentation/routes/admin.export-xlsx'
import { Route as AdminAuditLogRouteImport } from './presentation/routes/admin.audit-log'
import { Route as DashboardRegionsIndexRouteImport } from './presentation/routes/dashboard.regions.index'
import { Route as AdminUsersIndexRouteImport } from './presentation/routes/admin.users.index'
import { Route as SitesSiteIdRisksRouteImport } from './presentation/routes/sites.$siteId.risks'
import { Route as SitesSiteIdPreventionPlanRouteImport } from './presentation/routes/sites.$siteId.prevention-plan'
import { Route as SitesSiteIdDuerpVersionsRouteImport } from './presentation/routes/sites.$siteId.duerp-versions'
import { Route as SitesSiteIdComparisonRouteImport } from './presentation/routes/sites.$siteId.comparison'
import { Route as DashboardRegionsRegionIdRouteImport } from './presentation/routes/dashboard.regions.$regionId'
import { Route as AdminUsersMfaResetRequestsRouteImport } from './presentation/routes/admin.users.mfa-reset-requests'
import { Route as SitesSiteIdRisksNewRouteImport } from './presentation/routes/sites.$siteId.risks.new'
import { Route as SitesSiteIdRisksRiskIdRouteImport } from './presentation/routes/sites.$siteId.risks.$riskId'
import { Route as AdminWorkPhasesSiteIdWorkUnitIdWorkPhaseIdRouteImport } from './presentation/routes/admin.work-phases.$siteId.$workUnitId.$workPhaseId'

const SitesRoute = SitesRouteImport.update({
  id: '/sites',
  path: '/sites',
  getParentRoute: () => rootRouteImport,
} as any)
const RiskMatrixRoute = RiskMatrixRouteImport.update({
  id: '/risk-matrix',
  path: '/risk-matrix',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const PreventionPlanRoute = PreventionPlanRouteImport.update({
  id: '/prevention-plan',
  path: '/prevention-plan',
  getParentRoute: () => rootRouteImport,
} as any)
const ExportRoute = ExportRouteImport.update({
  id: '/export',
  path: '/export',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountRoute = AccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => rootRouteImport,
} as any)
const AcceptInviteRoute = AcceptInviteRouteImport.update({
  id: '/accept-invite',
  path: '/accept-invite',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SitesIndexRoute = SitesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SitesRoute,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/dashboard/',
  path: '/dashboard/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const SitesSiteIdRoute = SitesSiteIdRouteImport.update({
  id: '/$siteId',
  path: '/$siteId',
  getParentRoute: () => SitesRoute,
} as any)
const RisksNewRoute = RisksNewRouteImport.update({
  id: '/risks/new',
  path: '/risks/new',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRegionsRoute = DashboardRegionsRouteImport.update({
  id: '/dashboard/regions',
  path: '/dashboard/regions',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminWorkUnitsRoute = AdminWorkUnitsRouteImport.update({
  id: '/work-units',
  path: '/work-units',
  getParentRoute: () => AdminRoute,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSitesRoute = AdminSitesRouteImport.update({
  id: '/sites',
  path: '/sites',
  getParentRoute: () => AdminRoute,
} as any)
const AdminRegionsRoute = AdminRegionsRouteImport.update({
  id: '/regions',
  path: '/regions',
  getParentRoute: () => AdminRoute,
} as any)
const AdminImportRoute = AdminImportRouteImport.update({
  id: '/import',
  path: '/import',
  getParentRoute: () => AdminRoute,
} as any)
const AdminExportXlsxRoute = AdminExportXlsxRouteImport.update({
  id: '/export-xlsx',
  path: '/export-xlsx',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAuditLogRoute = AdminAuditLogRouteImport.update({
  id: '/audit-log',
  path: '/audit-log',
  getParentRoute: () => AdminRoute,
} as any)
const DashboardRegionsIndexRoute = DashboardRegionsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardRegionsRoute,
} as any)
const AdminUsersIndexRoute = AdminUsersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminUsersRoute,
} as any)
const SitesSiteIdRisksRoute = SitesSiteIdRisksRouteImport.update({
  id: '/risks',
  path: '/risks',
  getParentRoute: () => SitesSiteIdRoute,
} as any)
const SitesSiteIdPreventionPlanRoute =
  SitesSiteIdPreventionPlanRouteImport.update({
    id: '/prevention-plan',
    path: '/prevention-plan',
    getParentRoute: () => SitesSiteIdRoute,
  } as any)
const SitesSiteIdDuerpVersionsRoute =
  SitesSiteIdDuerpVersionsRouteImport.update({
    id: '/duerp-versions',
    path: '/duerp-versions',
    getParentRoute: () => SitesSiteIdRoute,
  } as any)
const SitesSiteIdComparisonRoute = SitesSiteIdComparisonRouteImport.update({
  id: '/comparison',
  path: '/comparison',
  getParentRoute: () => SitesSiteIdRoute,
} as any)
const DashboardRegionsRegionIdRoute =
  DashboardRegionsRegionIdRouteImport.update({
    id: '/$regionId',
    path: '/$regionId',
    getParentRoute: () => DashboardRegionsRoute,
  } as any)
const AdminUsersMfaResetRequestsRoute =
  AdminUsersMfaResetRequestsRouteImport.update({
    id: '/mfa-reset-requests',
    path: '/mfa-reset-requests',
    getParentRoute: () => AdminUsersRoute,
  } as any)
const SitesSiteIdRisksNewRoute = SitesSiteIdRisksNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => SitesSiteIdRisksRoute,
} as any)
const SitesSiteIdRisksRiskIdRoute = SitesSiteIdRisksRiskIdRouteImport.update({
  id: '/$riskId',
  path: '/$riskId',
  getParentRoute: () => SitesSiteIdRisksRoute,
} as any)
const AdminWorkPhasesSiteIdWorkUnitIdWorkPhaseIdRoute =
  AdminWorkPhasesSiteIdWorkUnitIdWorkPhaseIdRouteImport.update({
    id: '/work-phases/$siteId/$workUnitId/$workPhaseId',
    path: '/work-phases/$siteId/$workUnitId/$workPhaseId',
    getParentRoute: () => AdminRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/accept-invite': typeof AcceptInviteRoute
  '/account': typeof AccountRoute
  '/admin': typeof AdminRouteWithChildren
  '/export': typeof ExportRoute
  '/prevention-plan': typeof PreventionPlanRoute
  '/reset-password': typeof ResetPasswordRoute
  '/risk-matrix': typeof RiskMatrixRoute
  '/sites': typeof SitesRouteWithChildren
  '/admin/audit-log': typeof AdminAuditLogRoute
  '/admin/export-xlsx': typeof AdminExportXlsxRoute
  '/admin/import': typeof AdminImportRoute
  '/admin/regions': typeof AdminRegionsRoute
  '/admin/sites': typeof AdminSitesRoute
  '/admin/users': typeof AdminUsersRouteWithChildren
  '/admin/work-units': typeof AdminWorkUnitsRoute
  '/dashboard/regions': typeof DashboardRegionsRouteWithChildren
  '/risks/new': typeof RisksNewRoute
  '/sites/$siteId': typeof SitesSiteIdRouteWithChildren
  '/admin/': typeof AdminIndexRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/sites/': typeof SitesIndexRoute
  '/admin/users/mfa-reset-requests': typeof AdminUsersMfaResetRequestsRoute
  '/dashboard/regions/$regionId': typeof DashboardRegionsRegionIdRoute
  '/sites/$siteId/comparison': typeof SitesSiteIdComparisonRoute
  '/sites/$siteId/duerp-versions': typeof SitesSiteIdDuerpVersionsRoute
  '/sites/$siteId/prevention-plan': typeof SitesSiteIdPreventionPlanRoute
  '/sites/$siteId/risks': typeof SitesSiteIdRisksRouteWithChildren
  '/admin/users/': typeof AdminUsersIndexRoute
  '/dashboard/regions/': typeof DashboardRegionsIndexRoute
  '/sites/$siteId/risks/$riskId': typeof SitesSiteIdRisksRiskIdRoute
  '/sites/$siteId/risks/new': typeof SitesSiteIdRisksNewRoute
  '/admin/work-phases/$siteId/$workUnitId/$workPhaseId': typeof AdminWorkPhasesSiteIdWorkUnitIdWorkPhaseIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/accept-invite': typeof AcceptInviteRoute
  '/account': typeof AccountRoute
  '/export': typeof ExportRoute
  '/prevention-plan': typeof PreventionPlanRoute
  '/reset-password': typeof ResetPasswordRoute
  '/risk-matrix': typeof RiskMatrixRoute
  '/admin/audit-log': typeof AdminAuditLogRoute
  '/admin/export-xlsx': typeof AdminExportXlsxRoute
  '/admin/import': typeof AdminImportRoute
  '/admin/regions': typeof AdminRegionsRoute
  '/admin/sites': typeof AdminSitesRoute
  '/admin/work-units': typeof AdminWorkUnitsRoute
  '/risks/new': typeof RisksNewRoute
  '/sites/$siteId': typeof SitesSiteIdRouteWithChildren
  '/admin': typeof AdminIndexRoute
  '/dashboard': typeof DashboardIndexRoute
  '/sites': typeof SitesIndexRoute
  '/admin/users/mfa-reset-requests': typeof AdminUsersMfaResetRequestsRoute
  '/dashboard/regions/$regionId': typeof DashboardRegionsRegionIdRoute
  '/sites/$siteId/comparison': typeof SitesSiteIdComparisonRoute
  '/sites/$siteId/duerp-versions': typeof SitesSiteIdDuerpVersionsRoute
  '/sites/$siteId/prevention-plan': typeof SitesSiteIdPreventionPlanRoute
  '/sites/$siteId/risks': typeof SitesSiteIdRisksRouteWithChildren
  '/admin/users': typeof AdminUsersIndexRoute
  '/dashboard/regions': typeof DashboardRegionsIndexRoute
  '/sites/$siteId/risks/$riskId': typeof SitesSiteIdRisksRiskIdRoute
  '/sites/$siteId/risks/new': typeof SitesSiteIdRisksNewRoute
  '/admin/work-phases/$siteId/$workUnitId/$workPhaseId': typeof AdminWorkPhasesSiteIdWorkUnitIdWorkPhaseIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/accept-invite': typeof AcceptInviteRoute
  '/account': typeof AccountRoute
  '/admin': typeof AdminRouteWithChildren
  '/export': typeof ExportRoute
  '/prevention-plan': typeof PreventionPlanRoute
  '/reset-password': typeof ResetPasswordRoute
  '/risk-matrix': typeof RiskMatrixRoute
  '/sites': typeof SitesRouteWithChildren
  '/admin/audit-log': typeof AdminAuditLogRoute
  '/admin/export-xlsx': typeof AdminExportXlsxRoute
  '/admin/import': typeof AdminImportRoute
  '/admin/regions': typeof AdminRegionsRoute
  '/admin/sites': typeof AdminSitesRoute
  '/admin/users': typeof AdminUsersRouteWithChildren
  '/admin/work-units': typeof AdminWorkUnitsRoute
  '/dashboard/regions': typeof DashboardRegionsRouteWithChildren
  '/risks/new': typeof RisksNewRoute
  '/sites/$siteId': typeof SitesSiteIdRouteWithChildren
  '/admin/': typeof AdminIndexRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/sites/': typeof SitesIndexRoute
  '/admin/users/mfa-reset-requests': typeof AdminUsersMfaResetRequestsRoute
  '/dashboard/regions/$regionId': typeof DashboardRegionsRegionIdRoute
  '/sites/$siteId/comparison': typeof SitesSiteIdComparisonRoute
  '/sites/$siteId/duerp-versions': typeof SitesSiteIdDuerpVersionsRoute
  '/sites/$siteId/prevention-plan': typeof SitesSiteIdPreventionPlanRoute
  '/sites/$siteId/risks': typeof SitesSiteIdRisksRouteWithChildren
  '/admin/users/': typeof AdminUsersIndexRoute
  '/dashboard/regions/': typeof DashboardRegionsIndexRoute
  '/sites/$siteId/risks/$riskId': typeof SitesSiteIdRisksRiskIdRoute
  '/sites/$siteId/risks/new': typeof SitesSiteIdRisksNewRoute
  '/admin/work-phases/$siteId/$workUnitId/$workPhaseId': typeof AdminWorkPhasesSiteIdWorkUnitIdWorkPhaseIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/accept-invite'
    | '/account'
    | '/admin'
    | '/export'
    | '/prevention-plan'
    | '/reset-password'
    | '/risk-matrix'
    | '/sites'
    | '/admin/audit-log'
    | '/admin/export-xlsx'
    | '/admin/import'
    | '/admin/regions'
    | '/admin/sites'
    | '/admin/users'
    | '/admin/work-units'
    | '/dashboard/regions'
    | '/risks/new'
    | '/sites/$siteId'
    | '/admin/'
    | '/dashboard/'
    | '/sites/'
    | '/admin/users/mfa-reset-requests'
    | '/dashboard/regions/$regionId'
    | '/sites/$siteId/comparison'
    | '/sites/$siteId/duerp-versions'
    | '/sites/$siteId/prevention-plan'
    | '/sites/$siteId/risks'
    | '/admin/users/'
    | '/dashboard/regions/'
    | '/sites/$siteId/risks/$riskId'
    | '/sites/$siteId/risks/new'
    | '/admin/work-phases/$siteId/$workUnitId/$workPhaseId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/accept-invite'
    | '/account'
    | '/export'
    | '/prevention-plan'
    | '/reset-password'
    | '/risk-matrix'
    | '/admin/audit-log'
    | '/admin/export-xlsx'
    | '/admin/import'
    | '/admin/regions'
    | '/admin/sites'
    | '/admin/work-units'
    | '/risks/new'
    | '/sites/$siteId'
    | '/admin'
    | '/dashboard'
    | '/sites'
    | '/admin/users/mfa-reset-requests'
    | '/dashboard/regions/$regionId'
    | '/sites/$siteId/comparison'
    | '/sites/$siteId/duerp-versions'
    | '/sites/$siteId/prevention-plan'
    | '/sites/$siteId/risks'
    | '/admin/users'
    | '/dashboard/regions'
    | '/sites/$siteId/risks/$riskId'
    | '/sites/$siteId/risks/new'
    | '/admin/work-phases/$siteId/$workUnitId/$workPhaseId'
  id:
    | '__root__'
    | '/'
    | '/accept-invite'
    | '/account'
    | '/admin'
    | '/export'
    | '/prevention-plan'
    | '/reset-password'
    | '/risk-matrix'
    | '/sites'
    | '/admin/audit-log'
    | '/admin/export-xlsx'
    | '/admin/import'
    | '/admin/regions'
    | '/admin/sites'
    | '/admin/users'
    | '/admin/work-units'
    | '/dashboard/regions'
    | '/risks/new'
    | '/sites/$siteId'
    | '/admin/'
    | '/dashboard/'
    | '/sites/'
    | '/admin/users/mfa-reset-requests'
    | '/dashboard/regions/$regionId'
    | '/sites/$siteId/comparison'
    | '/sites/$siteId/duerp-versions'
    | '/sites/$siteId/prevention-plan'
    | '/sites/$siteId/risks'
    | '/admin/users/'
    | '/dashboard/regions/'
    | '/sites/$siteId/risks/$riskId'
    | '/sites/$siteId/risks/new'
    | '/admin/work-phases/$siteId/$workUnitId/$workPhaseId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AcceptInviteRoute: typeof AcceptInviteRoute
  AccountRoute: typeof AccountRoute
  AdminRoute: typeof AdminRouteWithChildren
  ExportRoute: typeof ExportRoute
  PreventionPlanRoute: typeof PreventionPlanRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  RiskMatrixRoute: typeof RiskMatrixRoute
  SitesRoute: typeof SitesRouteWithChildren
  DashboardRegionsRoute: typeof DashboardRegionsRouteWithChildren
  RisksNewRoute: typeof RisksNewRoute
  DashboardIndexRoute: typeof DashboardIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/sites': {
      id: '/sites'
      path: '/sites'
      fullPath: '/sites'
      preLoaderRoute: typeof SitesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/risk-matrix': {
      id: '/risk-matrix'
      path: '/risk-matrix'
      fullPath: '/risk-matrix'
      preLoaderRoute: typeof RiskMatrixRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/prevention-plan': {
      id: '/prevention-plan'
      path: '/prevention-plan'
      fullPath: '/prevention-plan'
      preLoaderRoute: typeof PreventionPlanRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/export': {
      id: '/export'
      path: '/export'
      fullPath: '/export'
      preLoaderRoute: typeof ExportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account': {
      id: '/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accept-invite': {
      id: '/accept-invite'
      path: '/accept-invite'
      fullPath: '/accept-invite'
      preLoaderRoute: typeof AcceptInviteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sites/': {
      id: '/sites/'
      path: '/'
      fullPath: '/sites/'
      preLoaderRoute: typeof SitesIndexRouteImport
      parentRoute: typeof SitesRoute
    }
    '/dashboard/': {
      id: '/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/sites/$siteId': {
      id: '/sites/$siteId'
      path: '/$siteId'
      fullPath: '/sites/$siteId'
      preLoaderRoute: typeof SitesSiteIdRouteImport
      parentRoute: typeof SitesRoute
    }
    '/risks/new': {
      id: '/risks/new'
      path: '/risks/new'
      fullPath: '/risks/new'
      preLoaderRoute: typeof RisksNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/regions': {
      id: '/dashboard/regions'
      path: '/dashboard/regions'
      fullPath: '/dashboard/regions'
      preLoaderRoute: typeof DashboardRegionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/work-units': {
      id: '/admin/work-units'
      path: '/work-units'
      fullPath: '/admin/work-units'
      preLoaderRoute: typeof AdminWorkUnitsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/sites': {
      id: '/admin/sites'
      path: '/sites'
      fullPath: '/admin/sites'
      preLoaderRoute: typeof AdminSitesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/regions': {
      id: '/admin/regions'
      path: '/regions'
      fullPath: '/admin/regions'
      preLoaderRoute: typeof AdminRegionsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/import': {
      id: '/admin/import'
      path: '/import'
      fullPath: '/admin/import'
      preLoaderRoute: typeof AdminImportRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/export-xlsx': {
      id: '/admin/export-xlsx'
      path: '/export-xlsx'
      fullPath: '/admin/export-xlsx'
      preLoaderRoute: typeof AdminExportXlsxRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/audit-log': {
      id: '/admin/audit-log'
      path: '/audit-log'
      fullPath: '/admin/audit-log'
      preLoaderRoute: typeof AdminAuditLogRouteImport
      parentRoute: typeof AdminRoute
    }
    '/dashboard/regions/': {
      id: '/dashboard/regions/'
      path: '/'
      fullPath: '/dashboard/regions/'
      preLoaderRoute: typeof DashboardRegionsIndexRouteImport
      parentRoute: typeof DashboardRegionsRoute
    }
    '/admin/users/': {
      id: '/admin/users/'
      path: '/'
      fullPath: '/admin/users/'
      preLoaderRoute: typeof AdminUsersIndexRouteImport
      parentRoute: typeof AdminUsersRoute
    }
    '/sites/$siteId/risks': {
      id: '/sites/$siteId/risks'
      path: '/risks'
      fullPath: '/sites/$siteId/risks'
      preLoaderRoute: typeof SitesSiteIdRisksRouteImport
      parentRoute: typeof SitesSiteIdRoute
    }
    '/sites/$siteId/prevention-plan': {
      id: '/sites/$siteId/prevention-plan'
      path: '/prevention-plan'
      fullPath: '/sites/$siteId/prevention-plan'
      preLoaderRoute: typeof SitesSiteIdPreventionPlanRouteImport
      parentRoute: typeof SitesSiteIdRoute
    }
    '/sites/$siteId/duerp-versions': {
      id: '/sites/$siteId/duerp-versions'
      path: '/duerp-versions'
      fullPath: '/sites/$siteId/duerp-versions'
      preLoaderRoute: typeof SitesSiteIdDuerpVersionsRouteImport
      parentRoute: typeof SitesSiteIdRoute
    }
    '/sites/$siteId/comparison': {
      id: '/sites/$siteId/comparison'
      path: '/comparison'
      fullPath: '/sites/$siteId/comparison'
      preLoaderRoute: typeof SitesSiteIdComparisonRouteImport
      parentRoute: typeof SitesSiteIdRoute
    }
    '/dashboard/regions/$regionId': {
      id: '/dashboard/regions/$regionId'
      path: '/$regionId'
      fullPath: '/dashboard/regions/$regionId'
      preLoaderRoute: typeof DashboardRegionsRegionIdRouteImport
      parentRoute: typeof DashboardRegionsRoute
    }
    '/admin/users/mfa-reset-requests': {
      id: '/admin/users/mfa-reset-requests'
      path: '/mfa-reset-requests'
      fullPath: '/admin/users/mfa-reset-requests'
      preLoaderRoute: typeof AdminUsersMfaResetRequestsRouteImport
      parentRoute: typeof AdminUsersRoute
    }
    '/sites/$siteId/risks/new': {
      id: '/sites/$siteId/risks/new'
      path: '/new'
      fullPath: '/sites/$siteId/risks/new'
      preLoaderRoute: typeof SitesSiteIdRisksNewRouteImport
      parentRoute: typeof SitesSiteIdRisksRoute
    }
    '/sites/$siteId/risks/$riskId': {
      id: '/sites/$siteId/risks/$riskId'
      path: '/$riskId'
      fullPath: '/sites/$siteId/risks/$riskId'
      preLoaderRoute: typeof SitesSiteIdRisksRiskIdRouteImport
      parentRoute: typeof SitesSiteIdRisksRoute
    }
    '/admin/work-phases/$siteId/$workUnitId/$workPhaseId': {
      id: '/admin/work-phases/$siteId/$workUnitId/$workPhaseId'
      path: '/work-phases/$siteId/$workUnitId/$workPhaseId'
      fullPath: '/admin/work-phases/$siteId/$workUnitId/$workPhaseId'
      preLoaderRoute: typeof AdminWorkPhasesSiteIdWorkUnitIdWorkPhaseIdRouteImport
      parentRoute: typeof AdminRoute
    }
  }
}

interface AdminUsersRouteChildren {
  AdminUsersMfaResetRequestsRoute: typeof AdminUsersMfaResetRequestsRoute
  AdminUsersIndexRoute: typeof AdminUsersIndexRoute
}

const AdminUsersRouteChildren: AdminUsersRouteChildren = {
  AdminUsersMfaResetRequestsRoute: AdminUsersMfaResetRequestsRoute,
  AdminUsersIndexRoute: AdminUsersIndexRoute,
}

const AdminUsersRouteWithChildren = AdminUsersRoute._addFileChildren(
  AdminUsersRouteChildren,
)

interface AdminRouteChildren {
  AdminAuditLogRoute: typeof AdminAuditLogRoute
  AdminExportXlsxRoute: typeof AdminExportXlsxRoute
  AdminImportRoute: typeof AdminImportRoute
  AdminRegionsRoute: typeof AdminRegionsRoute
  AdminSitesRoute: typeof AdminSitesRoute
  AdminUsersRoute: typeof AdminUsersRouteWithChildren
  AdminWorkUnitsRoute: typeof AdminWorkUnitsRoute
  AdminIndexRoute: typeof AdminIndexRoute
  AdminWorkPhasesSiteIdWorkUnitIdWorkPhaseIdRoute: typeof AdminWorkPhasesSiteIdWorkUnitIdWorkPhaseIdRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminAuditLogRoute: AdminAuditLogRoute,
  AdminExportXlsxRoute: AdminExportXlsxRoute,
  AdminImportRoute: AdminImportRoute,
  AdminRegionsRoute: AdminRegionsRoute,
  AdminSitesRoute: AdminSitesRoute,
  AdminUsersRoute: AdminUsersRouteWithChildren,
  AdminWorkUnitsRoute: AdminWorkUnitsRoute,
  AdminIndexRoute: AdminIndexRoute,
  AdminWorkPhasesSiteIdWorkUnitIdWorkPhaseIdRoute:
    AdminWorkPhasesSiteIdWorkUnitIdWorkPhaseIdRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

interface SitesSiteIdRisksRouteChildren {
  SitesSiteIdRisksRiskIdRoute: typeof SitesSiteIdRisksRiskIdRoute
  SitesSiteIdRisksNewRoute: typeof SitesSiteIdRisksNewRoute
}

const SitesSiteIdRisksRouteChildren: SitesSiteIdRisksRouteChildren = {
  SitesSiteIdRisksRiskIdRoute: SitesSiteIdRisksRiskIdRoute,
  SitesSiteIdRisksNewRoute: SitesSiteIdRisksNewRoute,
}

const SitesSiteIdRisksRouteWithChildren =
  SitesSiteIdRisksRoute._addFileChildren(SitesSiteIdRisksRouteChildren)

interface SitesSiteIdRouteChildren {
  SitesSiteIdComparisonRoute: typeof SitesSiteIdComparisonRoute
  SitesSiteIdDuerpVersionsRoute: typeof SitesSiteIdDuerpVersionsRoute
  SitesSiteIdPreventionPlanRoute: typeof SitesSiteIdPreventionPlanRoute
  SitesSiteIdRisksRoute: typeof SitesSiteIdRisksRouteWithChildren
}

const SitesSiteIdRouteChildren: SitesSiteIdRouteChildren = {
  SitesSiteIdComparisonRoute: SitesSiteIdComparisonRoute,
  SitesSiteIdDuerpVersionsRoute: SitesSiteIdDuerpVersionsRoute,
  SitesSiteIdPreventionPlanRoute: SitesSiteIdPreventionPlanRoute,
  SitesSiteIdRisksRoute: SitesSiteIdRisksRouteWithChildren,
}

const SitesSiteIdRouteWithChildren = SitesSiteIdRoute._addFileChildren(
  SitesSiteIdRouteChildren,
)

interface SitesRouteChildren {
  SitesSiteIdRoute: typeof SitesSiteIdRouteWithChildren
  SitesIndexRoute: typeof SitesIndexRoute
}

const SitesRouteChildren: SitesRouteChildren = {
  SitesSiteIdRoute: SitesSiteIdRouteWithChildren,
  SitesIndexRoute: SitesIndexRoute,
}

const SitesRouteWithChildren = SitesRoute._addFileChildren(SitesRouteChildren)

interface DashboardRegionsRouteChildren {
  DashboardRegionsRegionIdRoute: typeof DashboardRegionsRegionIdRoute
  DashboardRegionsIndexRoute: typeof DashboardRegionsIndexRoute
}

const DashboardRegionsRouteChildren: DashboardRegionsRouteChildren = {
  DashboardRegionsRegionIdRoute: DashboardRegionsRegionIdRoute,
  DashboardRegionsIndexRoute: DashboardRegionsIndexRoute,
}

const DashboardRegionsRouteWithChildren =
  DashboardRegionsRoute._addFileChildren(DashboardRegionsRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AcceptInviteRoute: AcceptInviteRoute,
  AccountRoute: AccountRoute,
  AdminRoute: AdminRouteWithChildren,
  ExportRoute: ExportRoute,
  PreventionPlanRoute: PreventionPlanRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  RiskMatrixRoute: RiskMatrixRoute,
  SitesRoute: SitesRouteWithChildren,
  DashboardRegionsRoute: DashboardRegionsRouteWithChildren,
  RisksNewRoute: RisksNewRoute,
  DashboardIndexRoute: DashboardIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
